FileDroppableMixin = require 'mixins/file-droppable'
EventedPromise = require 'utils/evented-promise'

App.ImportItemComponent = Em.Component.extend FileDroppableMixin,
	session: Em.inject.service()
	env: Em.inject.service('environment')
	notifier: Em.inject.service()

	classNames: ['import-item']

	duration: 1000 #milliseconds
	job: null
	# Нужно указать label чтобы показался чекбокс fromScratch
	fromScratchLabel: null
	fromScratch: false
	# Обязательно должен быть указан:
	# menu, clients и тд.
	type: null

	# Дочерние компоненты
	fileInput: null

	# Вычисляемые свойства
	isLoading: Ember.computed.equal 'job.job_status', 'upload'
	isQueued: Ember.computed.equal 'job.job_status', 'queued'
	isWorking: Ember.computed.equal 'job.job_status', 'working'
	isFree: Ember.computed.equal 'job.status', 'free'

	loadingProgress: Ember.computed.alias 'job.job_percent'
	jobProgressIsEmpty: Ember.computed 'job.job_percent', ->
		progress = @get 'job.job_percent'

		Ember.isEmpty progress

	statusTemplate: Ember.computed 'job.job_status', ->
		status = @get 'job.job_status'

		if !Ember.isEmpty status
			return "import.status.#{status}"
		else
			return null

	url: Ember.computed 'env.apiRoot', 'session.currentOrganization.id', 'type', 'fromScratch', ->
		baseRoot = @get 'env.apiRoot'
		id = @get 'session.currentOrganization.id'
		type = @get 'type'
		fromScratch = if @get 'fromScratch' then '?from_scratch=true' else ''

		"#{baseRoot}/api/organizations/#{id}/import/#{type}#{fromScratch}"

	# Обновляем job, увеличивая интервал
	jobObserver: Ember.observer('job', ->
		status = @get('job.status')

		return if not status?

		if status is 'free'
			notificationMessage = if @get('type') is 'clients'
	      # todo i18n
				'Импорт клиентов завершен успешно'
			else
	      # todo i18n
				'Импорт меню завершен успешно'

			@get('notifier').pushNotification
				type:     'success'
	      # todo i18n
				title:    'Импорт завершён'
				message:  notificationMessage

			return

		duration = @get 'duration'
		duration += 1000

		Ember.run.later @, @refreshJob, duration
	)

	init: ->
		@._super.apply(@, arguments)

		status = @get 'job.status'
		type = @get 'type'

		if status != 'free' then @jobObserver()

		if Ember.isEmpty type then Ember.Logger.error('Property "type" is required')

	refreshJob: ->
		key = @get 'session.apiKey'
		url = @get 'url'

		ajaxProps =
			url: url
			dataType: 'json'
			headers: 'Authorization': "Token token=\"#{key}\""
			context: @

		Ember.$.ajax(ajaxProps).then @setJob, @catchError

		false

	setJob: (job) ->
		# Убираем лишнее после нуля
		percent = Ember.get job, 'job_percent'
		if percent? then Ember.set job, 'job_percent', percent|0

		@set 'job', Ember.Object.create job

	catchError: (error) ->
		# Что делать то?
		console.error error

	actions:
		uploadFile: (file) ->
			@set 'job.job_message', file.name

			reader = new FileReader

			reader.onload = (event) =>
				text = event.target.result

				key = @get 'session.apiKey'
				URL = @get 'url'

				promise = null
				self = @
				ajaxProps =
					xhr: ->
						xhr = new window.XMLHttpRequest()
						xhr.upload.addEventListener 'progress', (evt) ->
							if evt.lengthComputable
								percent = evt.loaded / evt.total
								percent = parseInt(percent * 100)
								self.set('job.job_percent', percent)
						, false
						xhr
					url: URL
					dataType: 'json'
					headers: 'Authorization': "Token token=\"#{key}\""
					type: 'POST'
					data: text
					contentType: 'application/json'
					processData: false
					context: @

				@set 'job.job_status', 'upload'
				@set 'job.job_percent', 0

				Ember.$.ajax(ajaxProps).then (data) ->
					job = @get 'job'

					data.job_percent = 0
					data.job_status = "working"

					Ember.setProperties job, data
					@setJob job
				, @catchError

			reader.readAsText file

			false

		openFileDialog: ->
			@get('fileInput').openDialog()
			false
